import { reactive } from 'vue';

export type AuthorDialogAction = {
  label: string;
  primary?: boolean;
  onClick: () => void;
};

export type MessageDialogState = {
  /** Identifies the current message so callers can target it (e.g. auto-dismiss). */
  id: string;
  open: boolean;
  title: string;
  message: string;
  actions: AuthorDialogAction[];
};

/**
 * One shared message-dialog instance per host. A single `open` flag guarantees the
 * pending-review and editing-paused dialogs can never be shown at the same time.
 */
export default function useMessageDialog() {
  const messageDialog = reactive<MessageDialogState>({
    id: '',
    open: false,
    title: '',
    message: '',
    actions: []
  });

  const openMessageDialog = (cfg: Partial<MessageDialogState>) =>
    Object.assign(messageDialog, {
      id: '',
      title: '',
      message: '',
      actions: [],
      ...cfg,
      open: true
    });

  const closeMessageDialog = () => {
    messageDialog.open = false;
  };

  return { messageDialog, openMessageDialog, closeMessageDialog };
}
